
const StickyFooter = ({ isPatientAccess, isSubmitting, onSubmit }) => {
  return (
    <div className="sticky bottom-0 w-full bg-white px-4 py-3 z-50">
      <button
        type="button"
        className="bg-blue-600 text-white w-full py-3 rounded-lg text-base font-semibold hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
        onClick={onSubmit}
        disabled={isSubmitting}
      >
        {isSubmitting ? (isPatientAccess ? "Sending..." : "Saving...") : isPatientAccess ? "Send" : "Save"}
      </button>
    </div>
  );
};

export default StickyFooter;
